import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemRole extends React.Component {

  render() {
   let TenLoaiVaiTro = this.props.parent.state.DataLoaiVaiTro.map((item, i) => {
      if(this.props.item.loaiVaiTro == item.giaTri){
        return (
          <p key={i} >{item.ten}</p>
        )
      }
    });

    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ten}</li>
          </ul>
        </td>
        <td>
          {TenLoaiVaiTro}
        </td>
        <td dangerouslySetInnerHTML={{__html: this.props.item.moTa.replace(/\n/gi, '<br/>')}}>
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('VAITRO_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                  >
                  Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('VAITRO_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.vaiTroId}
                  />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemRole.jsx